import React from 'react';

import comfiGray from '../../assets/images/companies/comfi-gray-logo.svg';
import comfiColor from '../../assets/images/companies/comfi-logo.svg';
import credibleGray from '../../assets/images/companies/credible-gray-logo.svg';
import credibleColor from '../../assets/images/companies/credible-logo.svg';
import crossvalGray from '../../assets/images/companies/crossval-gray-logo.svg';
import crossvalColor from '../../assets/images/companies/crossval-logo.svg';
import holoGray from '../../assets/images/companies/holo-gray-logo.svg';
import holoColor from '../../assets/images/companies/holo-logo.svg';
import letsworkGray from '../../assets/images/companies/letswork-gray-logo.svg';
import letsworkColor from '../../assets/images/companies/letswork-logo.svg';
import mbrifGray from '../../assets/images/companies/mbrif-gray-logo.svg';
import mbrifColor from '../../assets/images/companies/mbrif-logo.svg';
import sunboxGray from '../../assets/images/companies/sunbox-gray-logo.svg';
import sunboxColor from '../../assets/images/companies/sunbox-logo.svg';
import svdjGray from '../../assets/images/companies/svdj-gray-logo.svg';
import svdjColor from '../../assets/images/companies/svdj-logo.svg';
import teylorGray from '../../assets/images/companies/teylor-gray-logo.svg';
import teylorColor from '../../assets/images/companies/teylor-logo.svg';
import greenhouseGray from '../../assets/images/companies/the-greenhouse-gray-logo.svg';
import greenhouseColor from '../../assets/images/companies/the-greenhouse-logo.svg';
import tribeGray from '../../assets/images/companies/tribe-gray-logo.svg';
import tribeColor from '../../assets/images/companies/tribe-logo.svg';

type Logo = {
  color: string;
  gray: string;
  name: string;
};

const logos: Logo[] = [
  { name: 'Comfi', gray: comfiGray, color: comfiColor },
  { name: 'Credible', gray: credibleGray, color: credibleColor },
  { name: 'Crossval', gray: crossvalGray, color: crossvalColor },
  { name: 'Holo', gray: holoGray, color: holoColor },
  { name: 'Letswork', gray: letsworkGray, color: letsworkColor },
  { name: 'MBRIF', gray: mbrifGray, color: mbrifColor },
  { name: 'Sunbox', gray: sunboxGray, color: sunboxColor },
  { name: 'SVDJ', gray: svdjGray, color: svdjColor },
  { name: 'Teylor', gray: teylorGray, color: teylorColor },
  { name: 'The Greenhouse', gray: greenhouseGray, color: greenhouseColor },
  { name: 'Tribe', gray: tribeGray, color: tribeColor },
];

const LOGO_SPACING = 'pr-[120px]';

const LOGO_HEIGHT = 'h-8';

const logoImageClass = `block ${LOGO_HEIGHT} w-auto object-contain transition-opacity duration-300`;

const LogoItem: React.FC<{ logo: Logo }> = ({ logo }) => (
  <div className={`group/logo flex shrink-0 items-center ${LOGO_HEIGHT} ${LOGO_SPACING}`}>
    <div className="relative inline-block">
      <img
        alt=""
        aria-hidden
        className={`${logoImageClass} group-hover/logo:opacity-0`}
        height={40}
        src={logo.gray}
      />
      <img
        alt={logo.name}
        className={`absolute left-0 top-0 opacity-0 group-hover/logo:opacity-100 ${logoImageClass}`}
        height={40}
        src={logo.color}
      />
    </div>
  </div>
);

export const CompanySlider: React.FC = () => (
  <div className="group/strip relative w-full overflow-hidden py-5">
    <div
      aria-label="Trusted partners"
      className="flex w-max animate-marquee items-center group-hover/strip:[animation-play-state:paused]"
      role="list"
    >
      {[...logos, ...logos].map((logo, index) => (
        <LogoItem key={`${logo.name}-${index}`} logo={logo} />
      ))}
    </div>
  </div>
);
